import { useQuery } from "@tanstack/react-query";
import { gateway } from "../../../../gateway";

interface DepositAvailable {
  depositInvoiceUid: string | null;
  depositAmount: number;
  /** Remaining deposit pool (computed on the server, not a DB column). */
  available: number;
  /** True when the deposit invoice counts as paid (invoice.paidAt or any payment method paidAt). */
  depositRecognizedPaid?: boolean;
  /** Quote `services[].serviceUid` that currently holds the deposit reservation (active job), if any. */
  depositReservedQuoteServiceUid?: string | null;
}

const fetchDepositAvailable = async (quoteId: number, excludeJobId?: number): Promise<DepositAvailable> => {
  const params: { excludeJobId?: number } = {};
  if (excludeJobId != null && Number.isFinite(Number(excludeJobId))) {
    params.excludeJobId = Number(excludeJobId);
  }
  const res = await gateway.get(`/quotes/${quoteId}/deposit-available`, {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return (res.data as any)?.data as DepositAvailable;
};

export const useQuoteDepositAvailable = (quoteId: number | null | undefined, excludeJobId?: number) => {
  return useQuery({
    queryKey: ["quote-deposit-available", quoteId, excludeJobId],
    queryFn: () => fetchDepositAvailable(Number(quoteId), excludeJobId),
    enabled: !!quoteId,
    staleTime: 10_000,
  });
};
